export default __webpack_public_path__ + "static/media/mars.45fe5069.png";